<template>
  <ul>
    <li>
      <div class="relative bg-white shadow-md px-5 py-8 flex flex-col gap-4">
        <div class="flex flex-row gap-4">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 32" class="w-7 h-7 shrink-0">
            <g id="clipboard" transform="translate(-3)">
              <path
                id="Path_4890"
                data-name="Path 4890"
                d="M19,4a3,3,0,0,0-6,0H10V8H22V4Z"
                fill="none"
                stroke="#991e66"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
              <path
                id="Path_4891"
                data-name="Path 4891"
                d="M25,5h3V31H4V5H7"
                fill="none"
                stroke="#991e66"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
              <line
                id="Line_317"
                data-name="Line 317"
                x2="15"
                transform="translate(8.5 14.5)"
                fill="none"
                stroke="#991e66"
                stroke-linecap="round"
                stroke-width="1"
              />
              <line
                id="Line_318"
                data-name="Line 318"
                x2="15"
                transform="translate(8.5 19.5)"
                fill="none"
                stroke="#991e66"
                stroke-linecap="round"
                stroke-width="1"
              />
              <line
                id="Line_319"
                data-name="Line 319"
                x2="15"
                transform="translate(8.5 24.5)"
                fill="none"
                stroke="#991e66"
                stroke-linecap="round"
                stroke-width="1"
              />
            </g>
          </svg>
          <BaseTypography disable-ellipsis class="text-sm font-medium">
            {{ $t("pages.account.drawer.guest.go_to_patient_area") }}
          </BaseTypography>
        </div>
        <a :href="resultsUrl" target="_blank">
          <BaseButton variant="contained" class="capitalize w-full">
            {{ $t("pages.account.drawer.guest.your_test_results") }}
          </BaseButton>
        </a>
      </div>
    </li>

    <template v-if="isHomeTestEnabled">
      <li>
        <NuxtLinkLocale
          :locale="switchBlogLocale()"
          to="/account"
          class="flex flex-row gap-4 items-center px-6 py-4 hover:bg-black/5"
        >
          <IconsDashboard class="w-5 h-5 shrink-0" />
          <BaseTypography class="font-semibold">{{ $t("pages.account.drawer.logged.dashboard") }}</BaseTypography>
        </NuxtLinkLocale>
      </li>
      <li>
        <NuxtLinkLocale
          :locale="switchBlogLocale()"
          to="/account/settings"
          class="flex flex-row gap-4 items-center px-6 py-4 hover:bg-black/5"
        >
          <IconsCogWheel class="w-5 h-5 shrink-0" />
          <BaseTypography class="font-semibold">{{ $t("pages.account.drawer.logged.settings") }}</BaseTypography>
        </NuxtLinkLocale>
      </li>
      <li>
        <div @click.prevent="logout" class="flex flex-row gap-4 items-center px-6 py-4 cursor-pointer hover:bg-black/5">
          <IconsLogout class="w-5 h-5 shrink-0" />
          <BaseTypography class="font-semibold">{{ $t("buttons.common.logout") }}</BaseTypography>
        </div>
      </li>
    </template>
  </ul>
</template>

<script setup lang="ts">
const testResults = useTestResults();
const resultsUrl = testResults.resultsUrl;

const globalStore = useGlobalStore();
const { isHomeTestEnabled } = storeToRefs(globalStore);
</script>
<style scoped lang="scss">
ul > li {
  @apply border-b;
}
</style>
